export const useFooterInfo = () => ({
  businessHours: 'pon - pt: 9.00 - 17.00',
  phone: '+48 511 929 482',
  email: 'pomoc@portalyogi.pl',
  facebookLink: 'https://www.facebook.com/portalyogipl',
  instagramLink: 'https://www.instagram.com/portalyogi_pl',
  youtubeLink: 'https://www.youtube.com/channel/UCRfe8VSaDrsLbbbSvvS7JDA',
  copyrightName: 'Internetowe Studio PortalYogi',
});
